import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import CurrentLocationIcon from '@material-ui/icons/MyLocation';
import HistoryLocationIcon from '@material-ui/icons/History';
import DeleteIcon from '@material-ui/icons/Delete';
import { observer } from "mobx-react";
import moment from 'moment'
import 'react-trumbowyg/dist/trumbowyg.min.css'
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';

const styles = theme => ({
  root: {
    width: '100%',
    padding: theme.spacing.unit * 3,
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    fullWidth: true,
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  }
});

class Map extends Component {
  render() {
    const GoogleMapsComponent = withGoogleMap(props => (
      <GoogleMap
        defaultCenter = { { lat: props.lat, lng: props.lon } }
        defaultZoom = { 10 }>
          <Marker position={{ lat: props.lat, lng: props.lon }} />
      </GoogleMap>
    ));
    return (
      <div>
        <GoogleMapsComponent
          lat={this.props.lat}
          lon={this.props.lon}
          containerElement={ <div style={{ height: `300px`, width: '100%' }} /> }
          mapElement={ <div style={{ height: `100%` }} /> }
        />
      </div>
    );
  }
};

class StickerLocation extends Component {

  constructor(props) {
    super(props);
    this.handleAddStickerLocation = this.handleAddStickerLocation.bind(this);
    this.handleLocationClick = this.handleLocationClick.bind(this);
    this.handleLocationDeleteClick = this.handleLocationDeleteClick.bind(this);
  }

  handleLocationClick(index) {
    this.props.stickerStore.selectedLocation = {
      lat: this.props.stickerStore.stickerLocations[index].lat,
      lon: this.props.stickerStore.stickerLocations[index].lon 
    }
  }

  handleLocationDeleteClick(uuid) {
    this.props.stickerStore.deleteStickerLocation(this.props.match.params.id, uuid);
  }

  handleAddStickerLocation() {
    this.props.stickerStore.addStickerLocation(this.props.match.params.id);
  }

  componentDidMount() {
    this.props.stickerStore.getStickerLocations(this.props.match.params.id);
  }

  render() {
    const { classes } = this.props;
    
    return (
      <div className={classes.root}>
        <Grid container spacing={24}>
          <Grid item xs={12} lg={6}>
            <Typography variant="h6" gutterBottom>
              Aktueller Standort
            </Typography>
            {this.props.stickerStore.stickerLocations.length > 0 &&
              <Map lat={this.props.stickerStore.selectedLocation.lat} lon={this.props.stickerStore.selectedLocation.lon}/>
            }
          </Grid>
        </Grid>
        <Grid container direction="column" spacing={24} style={{marginTop: "20px"}}>
          <Grid item xs={12} lg={6}>
            <Button variant="contained" color="secondary" fullWidth onClick={this.handleAddStickerLocation.bind(this)} className={classes.button}>
              Aktuellen Standort setzen
            </Button>
            {this.props.stickerStore.stickerLocations.length > 0 &&
              <Button variant="contained" color="primary" fullWidth className={classes.button} onClick={this.handleLocationDeleteClick.bind(this, this.props.stickerStore.stickerLocations[0].uuid)}>
                Aktuellen Standort löschen
              </Button>
            }
          </Grid>
        </Grid>
        <hr />
        <Grid container spacing={24}>
          <Grid item xs={12} lg={6}>
            <Typography variant="h6" gutterBottom>
              Historie
            </Typography>
            <List button="true">
            {this.props.stickerStore.stickerLocations.map((location, index) =>
              <ListItem key={location.uuid} button onClick={this.handleLocationClick.bind(this,index)}>
                {index === 0  ? (
                <Fragment>
                  <ListItemIcon>
                    <CurrentLocationIcon />
                  </ListItemIcon>
                  <ListItemText>
                    <strong>{moment(location.tracked).format("DD.MM.YYYY, HH:mm")}</strong>
                  </ListItemText>
                </Fragment>
                ) : (
                <Fragment>
                  <ListItemIcon>
                    <HistoryLocationIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {moment(location.tracked).format("DD.MM.YYYY, HH:mm")}
                  </ListItemText>
                </Fragment>
                )}
                <ListItemSecondaryAction>
                  <IconButton edge="end" aria-label="comments" onClick={this.handleLocationDeleteClick.bind(this, location.uuid)}>
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            )}
            </List>
          </Grid>
        </Grid>
        </div>
    );
  }
}

export default withStyles(styles)(observer(StickerLocation));
